<template>
  <div id="Player">
    <div class="grid" :class="'grid-'+pos">
      <div class="player-box">
        <div id="name-box">
          <h3 class="name">{{ player.name }}</h3>
        </div>
        <div id="playerBox" class="flex player-color" v-bind:class="{ myTurn: player.is_user_turn == 1 }">
          <div id="player-info">
            <div id="player-dealer" v-if="player.is_dealer">
              <img id="dealer-img" alt="dealer" :src="require('../assets/crown.png')" width="40" height="40" />
            </div>
            <div id="player-points">
              <h3>{{ player.total_score }}</h3>
            </div>
          </div>
          <div>
            <img v-if="player.is_bot" id="user-image" alt="user" :src="require('../assets/bot.jpg')" width="80" height="80" />
            <img v-else id="user-image" alt="user" :src="require('../assets/user.jpg')" width="80" height="80" />
          </div>
        </div>
        <Bubble v-if="callSection != 'finished' && player.called_card" 
          :called_card="player.called_card" 
          :called_points="Number(player.called_points)">
        </Bubble>
      </div>
      <div id="took-box">
        <img id="took" v-if="took && user.id != player.id" 
          class="deck" 
          alt="mazzo" 
          :src="require('../assets/cards/duca.png')" 
          width="90" 
          height="162"
          :class="'took-'+pos"
          />
      </div>
    </div>
  </div>
</template>

<script>
import Bubble from "@/components/Bubble";
import { mapGetters } from "vuex";

export default {
  name: "Player",
  components: {
    Bubble,
  },
  props: {
    player: {
      type: Object,
      required: true
    },
    pos: {
      type: Number,
      required: true
    },
    took: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters({ 
      callSection: "call/callSection",
      user: "user/user"
    })
  },
};
</script>
<style scoped>
#playerBox {
  width: 150px;
  height: 90px;
  border-radius: 10px;
}
img.deck {
  margin:0.75em;
}
.took-1{
  transform: rotate(90deg);
} 
.took-4{
  transform: rotate(90deg);
  margin-top: 6em !important;
  margin-left: 2em !important;
}
.grid-0{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 50px 50px;
  grid-template-areas: 
    'took player'
    'took player';
}
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 100px 100px;
}
.grid-0{
  grid-template-areas: 
    'took player'
    'took player';
}
.grid-1 {
  grid-template-areas: 
    'player player'
    'took took';
}
.grid-2 {
  grid-template-areas: 
    'player took'
    'player took';
}
.grid-3 {
  grid-template-areas: 
    'took player'
    'took player';
}
.grid-4 {
  grid-template-areas: 
    'took took'
    'player player';
}
#took-box{
  grid-area: took;
}
#player-box {
  grid-area: player;
}
#name-box {
  color: antiquewhite;
  font-size: 12px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
#player-info{
  display: flex;
  flex-direction: column;
}
.player-color {
  background-color:black;
  color: antiquewhite;
}
.myTurn {
  background-color: lightseagreen;
  border: solid 4px black;
  color: black;
}
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.name {
  margin-left: 0.5em;
}
@media all and (min-width: 960px) {
  #took {
      width: 90px;
      height: 162px;
      margin: 1em;
  }
}

@media all and (min-width: 760px) and (max-width: 960px) {
  #took {
    width: 80px;
    height: 150px;
  }
}
@media all and (min-width: 685px) and (max-width: 760px) {
  #took {
    width: 70px;
    height: 130px;
  }
  #playerBox {
    width: 130px;
    height: 70px;
    border-radius: 10px;
  }
  #user-image {
    width: 45px;
    height: 45px;
  }
}
@media all and (min-width: 570px) and (max-width: 685px) {
  #playerBox {
    width: 130px;
    height: 50px;
    border-radius: 10px;
  }

  #user-image {
    width: 35px;
    height: 35px;
  }
  #dealer-img {
    width: 25px;
    height: 20px;
  }
  #took {
    width: 60px;
    height: 113px;
  }
}
@media all and (max-width: 570px) {
  #user-image {
    width: 30px;
    height: 30px;
  }
  #dealer-img {
    width: 25px;
    height: 20px;
  }

  #playerBox {
    width: 130px;
    height: 50px;
    border-radius: 10px;
  }
  #took {
    width: 50px;
    height: 100px;
  }
}
@media all and (max-height: 750px) {
  #playerBox {
    width: 130px;
    height: 50px;
    border-radius: 10px;
  }
  #user-image {
    width: 35px;
    height: 35px;
  }
  #dealer-img {
    width: 25px;
    height: 20px;
  }
  #took {
    width: 45px;
    height: 85px;
  }
}
@media all and (max-height: 500px) {
  #name-box {
    font-size: 10px;
  }
  .grid {
      grid-template-rows: 40px 40px;
  }
  .took-4[data-v-68eae891] {
    margin-top: 3em !important;
  }
}
</style>
